module.exports =
  calendar: '55a5d917446f517774210011'
  cardAging: '55a5d917446f517774210012'
  voting: '55a5d917446f517774210013'



// WEBPACK FOOTER //
// ./app/scripts/data/legacy-power-ups.coffee